const isStatusUpdated = (algo = {}, status = '') => {
  const { status: algoStatus = '' } = algo;

  return status !== algoStatus ? true : false;
};

const isAgoStatusUpdated = (algo = {}, algoStatus = '') => {
  const { algoStatus: algoAlgoStatus = '' } = algo;

  return algoStatus !== algoAlgoStatus ? true : false;
};

const isHasErrorUpdated = (
  algo = {},
  hasError = false,
  entryErrorCount = 0,
  exitErrorCount = 0
) => {
  const {
    hasError: algoHasError = false,
    entryErrorCount: algoEntryErrorCount = 0,
    exitErrorCount: algoExitErrorCount = 0,
  } = algo;

  if (entryErrorCount !== algoEntryErrorCount) {
    return true;
  }

  if (exitErrorCount !== algoExitErrorCount) {
    return true;
  }

  if (hasError !== algoHasError) {
    return true;
  }

  return false;
};

const isHasWaitingUpdated = (algo = {}, hasWaiting = false) => {
  const { hasWaiting: algoHasWaiting = false } = algo;

  return hasWaiting !== algoHasWaiting ? true : false;
};

const isHasWaitingWTUpdated = (algo = {}, hasWaitingWT = false) => {
  const { hasWaitingWT: algoHasWaitingWT = false } = algo;

  return hasWaitingWT !== algoHasWaitingWT ? true : false;
};

const findDayIndex = (day, data) => {
  let dayIndexPicked = null;
  let found = false;
  for (let index = 0; index < data.length; index++) {
    const { day: dataDay = '' } = data[index] || {};

    if (dataDay === day) {
      dayIndexPicked = index;
      found = true;
    }
  }

  return {
    dayIndex: dayIndexPicked,
    found,
  };
};

const findLoactionByAlgoid = (id, data) => {
  let dayPicked = '';
  let algoIndexPicked = null;
  let dayIndexPicked = null;
  let found = false;
  for (let index = 0; index < data.length; index++) {
    const { algos = [] } = data[index] || {};

    const { day = '' } = algos.find((a) => a._id === id) || {};
    const algoIndex = algos.findIndex((a) => a._id === id);

    if (day && algoIndex >= 0) {
      dayPicked = day;
      algoIndexPicked = algoIndex;
      dayIndexPicked = index;
      found = true;
    }
  }

  return {
    day: dayPicked,
    algoIndex: algoIndexPicked,
    dayIndex: dayIndexPicked,
    found,
  };
};

export const updateRefreshHealthStatus = (state, action) => {
  const data = state.data && state.data.data ? state.data.data : [];
  const dataCached =
    state.dataCached && state.dataCached.data ? state.dataCached.data : [];
  const algos = action.data && action.data.algos ? action.data.algos : [];
  let updateTime = state.updateTime;
  let isUpdateSkipped = state.isUpdateSkipped;

  if (!data.length) {
    return {
      data: {
        ...state.data,
        data: [],
      },
      dataCached: {
        ...state.dataCached,
        data: [],
      },
      updateTime,
      isUpdateSkipped,
    };
  }

  if (!algos.length) {
    return {
      data: {
        ...state.data,
        data: data,
      },
      dataCached: {
        ...state.dataCached,
        dataCached: dataCached,
      },
      updateTime,
      isUpdateSkipped,
    };
  }

  for (let index = 0; index < algos.length; index++) {
    const { id, status = '' } = algos[index];
    const { algoIndex, dayIndex, found } = findLoactionByAlgoid(id, data);

    if (found) {
      if (
        isAgoStatusUpdated(data[dayIndex].algos[algoIndex], status) ||
        isUpdateSkipped
      ) {
        const now = new Date();
        const diffTime = Math.abs(now - updateTime);

        if (diffTime >= 10000) {
          updateTime = now;
          isUpdateSkipped = false;
        } else {
          isUpdateSkipped = true;
        }
      }

      if (!data[dayIndex].algos[algoIndex].algoStatus) {
        data[dayIndex].algos[algoIndex].algoStatus = '';
      }

      data[dayIndex].algos[algoIndex].algoStatus = status;
    }

    // cached
    const { algoIndex2, dayIndex2, found2 } = findLoactionByAlgoid(
      id,
      dataCached
    );

    if (found2) {
      if (!dataCached[dayIndex2].algos[algoIndex2].algoStatus) {
        dataCached[dayIndex2].algos[algoIndex2].algoStatus = '';
      }

      dataCached[dayIndex2].algos[algoIndex2].algoStatus = status;
    }
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
    dataCached: {
      ...state.dataCached,
      dataCached: dataCached,
    },
    updateTime,
    isUpdateSkipped,
  };
};

export const updateRefreshPositionsUpdates = (state, action) => {
  const data = state.data && state.data.data ? state.data.data : [];
  const dataCached =
    state.dataCached && state.dataCached.data ? state.dataCached.data : [];
  let updateTime = state.updateTime;
  let isUpdateSkipped = state.isUpdateSkipped;

  if (!data.length) {
    return {
      data: {
        ...state.data,
        data: [],
      },
      dataCached: {
        ...state.dataCached,
        data: [],
      },
      updateTime,
      isUpdateSkipped,
    };
  }

  if (!action.data) {
    return {
      data: {
        ...state.data,
        data: data,
      },
      dataCached: {
        ...state.dataCached,
        data: dataCached,
      },
      updateTime,
      isUpdateSkipped,
    };
  }

  if (typeof action.data !== 'string') {
    return {
      data: {
        ...state.data,
        data: data,
      },
      dataCached: {
        ...state.dataCached,
        data: dataCached,
      },
      updateTime,
      isUpdateSkipped,
    };
  }

  let [
    algoId,
    ,
    ,
    ,
    pnl,
    hasErrorRaw = '',
    ,
    hasWaiting = 'false',
    hasWaitingWT = 'false',
  ] = action.data.split(',');

  if (algoId) {
    const { algoIndex, dayIndex, found } = findLoactionByAlgoid(algoId, data);

    const [
      hasErrorFlag = 'false',
      entryErrorCountRaw = '0',
      exitErrorCountRaw = '0',
    ] = hasErrorRaw.split(':');

    const entryErrorCount = Number(entryErrorCountRaw);
    const exitErrorCount = Number(exitErrorCountRaw);

    pnl = pnl === '' ? pnl : Number(pnl);
    const hasError = hasErrorFlag === 'true' ? true : false;
    hasWaiting = hasWaiting === 'true' ? true : false;
    hasWaitingWT = hasWaitingWT === 'true' ? true : false;

    if (found) {
      if (
        isHasErrorUpdated(
          data[dayIndex].algos[algoIndex],
          hasError,
          entryErrorCount,
          exitErrorCount
        ) ||
        isHasWaitingUpdated(data[dayIndex].algos[algoIndex], hasWaiting) ||
        isHasWaitingWTUpdated(data[dayIndex].algos[algoIndex], hasWaitingWT) ||
        isUpdateSkipped
      ) {
        const now = new Date();
        const diffTime = Math.abs(now - updateTime);

        if (diffTime >= 10000) {
          updateTime = now;
          isUpdateSkipped = false;
        } else {
          isUpdateSkipped = true;
        }
      }

      if (data[dayIndex].algos[algoIndex].pnlUpdate) {
        const now = new Date();
        const diffTime = Math.abs(
          now - data[dayIndex].algos[algoIndex].pnlUpdate
        );

        if (diffTime >= 1000) {
          data[dayIndex].algos[algoIndex].pnl = pnl;
          data[dayIndex].algos[algoIndex].pnlUpdate = new Date();
        }
      } else {
        data[dayIndex].algos[algoIndex].pnl = pnl;
        data[dayIndex].algos[algoIndex].pnlUpdate = new Date();
      }

      data[dayIndex].algos[algoIndex].hasError = hasError;
      data[dayIndex].algos[algoIndex].entryErrorCount = entryErrorCount;
      data[dayIndex].algos[algoIndex].exitErrorCount = exitErrorCount;
      data[dayIndex].algos[algoIndex].hasWaiting = hasWaiting;
      data[dayIndex].algos[algoIndex].hasWaitingWT = hasWaitingWT;
    }

    // cached
    const { algoIndex2, dayIndex2, found2 } = findLoactionByAlgoid(
      algoId,
      dataCached
    );

    if (found2) {
      if (dataCached[dayIndex2].algos[algoIndex2].pnlUpdate) {
        const now = new Date();
        const diffTime = Math.abs(
          now - dataCached[dayIndex2].algos[algoIndex2].pnlUpdate
        );

        if (diffTime >= 1000) {
          dataCached[dayIndex2].algos[algoIndex2].pnl = pnl;
          dataCached[dayIndex2].algos[algoIndex2].pnlUpdate = new Date();
        }
      } else {
        dataCached[dayIndex2].algos[algoIndex2].pnl = pnl;
        dataCached[dayIndex2].algos[algoIndex2].pnlUpdate = new Date();
      }

      dataCached[dayIndex2].algos[algoIndex2].hasError = hasError;
      data[dayIndex].algos[algoIndex].entryErrorCount = entryErrorCount;
      data[dayIndex].algos[algoIndex].exitErrorCount = exitErrorCount;
      dataCached[dayIndex2].algos[algoIndex2].hasWaiting = hasWaiting;
      dataCached[dayIndex2].algos[algoIndex2].hasWaitingWT = hasWaitingWT;
    }
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
    dataCached: {
      ...state.dataCached,
      data: dataCached,
    },
    updateTime,
    isUpdateSkipped,
  };
};

export const updateCommonChange = (state, action) => {
  const data = state.data && state.data.data ? state.data.data : [];
  const dataCached =
    state.dataCached && state.dataCached.data ? state.dataCached.data : [];

  if (!data.length) {
    return {
      data: {
        ...state.data,
        data: [],
      },
      dataCached: {
        ...state.dataCached,
        data: [],
      },
    };
  }

  if (!action.data || !action.data.fullData || !action.data.fullData._id) {
    return {
      data: {
        ...state.data,
        data: data,
      },
      dataCached: {
        ...state.dataCached,
        data: dataCached,
      },
    };
  }

  const { algoIndex, dayIndex, found } = findLoactionByAlgoid(
    action.data.fullData._id,
    data
  );

  if (found) {
    data[dayIndex].algos[algoIndex] = Object.assign(
      {},
      data[dayIndex].algos[algoIndex],
      action.data.fullData
    );
  }

  // cached
  const { algoIndex2, dayIndex2, found2 } = findLoactionByAlgoid(
    action.data.fullData._id,
    dataCached
  );

  if (found2) {
    dataCached[dayIndex2].algos[algoIndex2] = Object.assign(
      {},
      dataCached[dayIndex2].algos[algoIndex2],
      action.data.fullData
    );
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
    dataCached: {
      ...state.dataCached,
      data: dataCached,
    },
  };
};

export const updateToggleEnable = (state, action) => {
  const data = state.data && state.data.data ? state.data.data : [];
  const dataCached =
    state.dataCached && state.dataCached.data ? state.dataCached.data : [];

  if (!data.length) {
    return {
      data: {
        ...state.data,
        data: [],
      },
      dataCached: {
        ...state.dataCached,
        data: [],
      },
    };
  }

  if (!action.data || !action.data.id) {
    return {
      data: {
        ...state.data,
        data: data,
      },
      dataCached: {
        ...state.dataCached,
        data: dataCached,
      },
    };
  }

  const { algoIndex, dayIndex, found } = findLoactionByAlgoid(
    action.data.id,
    data
  );

  if (found) {
    data[dayIndex].algos[algoIndex].enabled = action.data.enabled;
  }

  // cached
  const { algoIndex2, dayIndex2, found2 } = findLoactionByAlgoid(
    action.data.id,
    dataCached
  );

  if (found2) {
    dataCached[dayIndex2].algos[algoIndex2].enabled = action.data.enabled;
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
    dataCached: {
      ...state.dataCached,
      data: dataCached,
    },
  };
};

export const updateToggleEnableLoading = (state, action) => {
  const data = state.data && state.data.data ? state.data.data : [];
  const dataCached =
    state.dataCached && state.dataCached.data ? state.dataCached.data : [];

  if (!data.length) {
    return {
      data: {
        ...state.data,
        data: [],
      },
      dataCached: {
        ...state.dataCached,
        data: [],
      },
    };
  }

  if (!action.data || !action.data.id) {
    return {
      data: {
        ...state.data,
        data: data,
      },
      dataCached: {
        ...state.dataCached,
        data: dataCached,
      },
    };
  }

  const { algoIndex, dayIndex, found } = findLoactionByAlgoid(
    action.data.id,
    data
  );

  if (found) {
    data[dayIndex].algos[algoIndex].enabledLoading = action.data.loading;
  }

  // cached
  const { algoIndex2, dayIndex2, found2 } = findLoactionByAlgoid(
    action.data.id,
    dataCached
  );

  if (found2) {
    dataCached[dayIndex2].algos[algoIndex2].enabledLoading =
      action.data.loading;
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
    dataCached: {
      ...state.dataCached,
      data: dataCached,
    },
  };
};

export const updateCommonUppendData = (state, action) => {
  const data = state.data && state.data.data ? state.data.data : [];

  if (!data.length) {
    return {
      ...state.data,
      data: [],
    };
  }

  if (!action.data || !action.data.fullData || !action.data.fullData.length) {
    return {
      ...state.data,
      data,
    };
  }

  for (let index = 0; index < action.data.fullData.length; index++) {
    const element = action.data.fullData[index];

    const { day = '' } = element;
    const { dayIndex, found } = findDayIndex(day, data);

    if (found) {
      data[dayIndex].algos = [element, ...data[dayIndex].algos];
    }
  }

  return {
    ...state.data,
    data,
  };
};

export const updateDeleteAlgo = (state, action) => {
  const data = state.data && state.data.data ? state.data.data : [];

  if (!data.length) {
    return {
      data: {
        ...state.data,
        data: [],
      },
    };
  }

  if (!action.data || !action.data.id) {
    return {
      data: {
        ...state.data,
        data: data,
      },
    };
  }

  const { dayIndex, found } = findLoactionByAlgoid(action.data.id, data);

  if (found) {
    data[dayIndex].algos =
      data[dayIndex].algos.filter((a) => a._id !== action.data.id) || [];
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
  };
};

export const updateBulkDeleteAlgo = (state, action) => {
  const data = state.data && state.data.data ? state.data.data : [];
  const dataCached =
    state.dataCached && state.dataCached.data ? state.dataCached.data : [];

  if (!data.length) {
    return {
      data: {
        ...state.data,
        data: [],
      },
      dataCached: {
        ...state.dataCached,
        data: [],
      },
    };
  }

  if (!action.data || !action.data.ids || !action.data.ids.length) {
    return {
      data: {
        ...state.data,
        data: data,
      },
      dataCached: {
        ...state.dataCached,
        data: dataCached,
      },
    };
  }

  for (let index = 0; index < action.data.ids.length; index++) {
    const element = action.data.ids[index];
    const { dayIndex, found } = findLoactionByAlgoid(element.algoId, data);

    if (found) {
      data[dayIndex].algos =
        data[dayIndex].algos.filter((a) => a._id !== element.algoId) || [];
    }

    // cached
    const { dayIndex2, found2 } = findLoactionByAlgoid(
      element.algoId,
      dataCached
    );

    if (found2) {
      dataCached[dayIndex2].algos =
        dataCached[dayIndex2].algos.filter((a) => a._id !== element.algoId) ||
        [];
    }
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
    dataCached: {
      ...state.dataCached,
      data: dataCached,
    },
  };
};

export const updateBulkDuplicateAlgo = (state) => {
  const data = state.data && state.data.data ? state.data.data : [];

  if (!data.length) {
    return {
      ...state.data,
      data: [],
    };
  }

  // if (!action.data || !action.data.ids || !action.data.ids.length) {
  //   return {
  //     ...state.data,
  //     data: data,
  //   };
  // }

  // action.data.ids.forEach((d) => {
  //   const { dayIndex, found } = findLoactionByAlgoid(d.algoId, data);

  //   if (found) {
  //     data[dayIndex].algos =
  //       data[dayIndex].algos.filter((a) => a._id !== d.algoId) || [];
  //   }
  // });

  return {
    ...state.data,
    data: data,
  };
};

export const updateBulkEnableDisableAlgo = (
  state,
  action,
  method = 'enable'
) => {
  const data = state.data && state.data.data ? state.data.data : [];
  const dataCached =
    state.dataCached && state.dataCached.data ? state.dataCached.data : [];

  if (!data.length) {
    return {
      data: {
        ...state.data,
        data: [],
      },
      dataCached: {
        ...state.dataCached,
        data: [],
      },
    };
  }

  if (!action.data || !action.data.ids || !action.data.ids.length) {
    return {
      data: {
        ...state.data,
        data: data,
      },
      dataCached: {
        ...state.dataCached,
        data: dataCached,
      },
    };
  }

  for (let index = 0; index < action.data.ids.length; index++) {
    const element = action.data.ids[index];

    const { dayIndex, found } = findLoactionByAlgoid(element.id, data);

    if (found) {
      data[dayIndex].algos =
        data[dayIndex].algos.map((a) => {
          if (a._id !== element.id) {
            return a;
          }

          if (element.success && element.success === true) {
            a.enabled = method === 'enable' ? true : false;
          }

          a.selected = false;

          return a;
        }) || [];
    }

    // cached
    const { dayIndex2, found2 } = findLoactionByAlgoid(element.id, dataCached);

    if (found2) {
      dataCached[dayIndex2].algos =
        dataCached[dayIndex2].algos.map((a) => {
          if (a._id !== element.id) {
            return a;
          }

          if (element.success && element.success === true) {
            a.enabled = method === 'enable' ? true : false;
          }

          a.selected = false;

          return a;
        }) || [];
    }
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
    dataCached: {
      ...state.dataCached,
      data: dataCached,
    },
  };
};

export const updateBulkAlgoClearSpecific = (state, action) => {
  const data = state.data && state.data.data ? state.data.data : [];
  const dataCached =
    state.dataCached && state.dataCached.data ? state.dataCached.data : [];

  if (!data.length) {
    return {
      data: {
        ...state.data,
        data: [],
      },
      dataCached: {
        ...state.dataCached,
        data: [],
      },
    };
  }

  if (!action.data || !action.data.algoIds || !action.data.algoIds.length) {
    return {
      data: {
        ...state.data,
        data: data,
      },
      dataCached: {
        ...state.dataCached,
        data: dataCached,
      },
    };
  }

  for (let index = 0; index < action.data.algoIds.length; index++) {
    const algoId = action.data.algoIds[index];

    const { dayIndex, found } = findLoactionByAlgoid(algoId, data);

    if (found) {
      data[dayIndex].algos =
        data[dayIndex].algos.map((a) => {
          if (a._id !== algoId) {
            return a;
          }

          a.selected = false;

          return a;
        }) || [];
    }

    // cached
    const { dayIndex2, found2 } = findLoactionByAlgoid(algoId, dataCached);

    if (found2) {
      dataCached[dayIndex2].algos =
        dataCached[dayIndex2].algos.map((a) => {
          if (a._id !== algoId) {
            return a;
          }

          a.selected = false;

          return a;
        }) || [];
    }
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
    dataCached: {
      ...state.dataCached,
      data: dataCached,
    },
  };
};

export const updateToggleSelect = (state, action) => {
  const data = state.data && state.data.data ? state.data.data : [];
  const dataCached =
    state.dataCached && state.dataCached.data ? state.dataCached.data : [];

  if (!data.length) {
    return {
      data: {
        ...state.data,
        data: [],
      },
      dataCached: {
        ...state.dataCached,
        data: [],
      },
    };
  }

  if (!action.data || !action.data.id) {
    return {
      data: {
        ...state.data,
        data: data,
      },
      dataCached: {
        ...state.dataCached,
        data: dataCached,
      },
    };
  }

  const { algoIndex, dayIndex, found } = findLoactionByAlgoid(
    action.data.id,
    data
  );

  if (found) {
    if (data[dayIndex].algos[algoIndex].selected === true) {
      data[dayIndex].algos[algoIndex].selected = false;
    } else {
      data[dayIndex].algos[algoIndex].selected = true;
    }
  }

  // cached
  const { algoIndex2, dayIndex2, found2 } = findLoactionByAlgoid(
    action.data.id,
    dataCached
  );

  if (found2) {
    if (dataCached[dayIndex2].algos[algoIndex2].selected === true) {
      dataCached[dayIndex2].algos[algoIndex2].selected = false;
    } else {
      dataCached[dayIndex2].algos[algoIndex2].selected = true;
    }
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
    dataCached: {
      ...state.dataCached,
      data: dataCached,
    },
  };
};

export const updateClearAllSelect = (state) => {
  const data = state.data && state.data.data ? state.data.data : [];
  const dataCached =
    state.dataCached && state.dataCached.data ? state.dataCached.data : [];

  if (!data.length) {
    return {
      data: {
        ...state.data,
        data: [],
      },
      dataCached: {
        ...state.dataCached,
        data: [],
      },
    };
  }

  for (let dayIndex = 0; dayIndex < data.length; dayIndex++) {
    const dataDay = data[dayIndex] || {};

    if (dataDay.algos && dataDay.algos.length) {
      for (let algoIndex = 0; algoIndex < dataDay.algos.length; algoIndex++) {
        data[dayIndex].algos[algoIndex].selected = false;
      }
    }
  }

  // cached
  for (let dayIndex = 0; dayIndex < data.length; dayIndex++) {
    const dataDay = dataCached[dayIndex] || {};

    if (dataDay.algos && dataDay.algos.length) {
      for (let algoIndex = 0; algoIndex < dataDay.algos.length; algoIndex++) {
        dataCached[dayIndex].algos[algoIndex].selected = false;
      }
    }
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
    dataCached: {
      ...state.dataCached,
      data: dataCached,
    },
  };
};

const selectionSetter = (algo = {}, value) => {
  switch (value) {
    case 'ENABLED':
      if (algo.enabled) {
        algo.selected = true;
      } else {
        algo.selected = false;
      }
      break;
    case 'DISABLED':
      if (!algo.enabled) {
        algo.selected = true;
      } else {
        algo.selected = false;
      }
      break;
    case 'TRADE_ACTIVE':
      if (algo.status === 'TRADE_ACTIVE') {
        algo.selected = true;
      } else {
        algo.selected = false;
      }
      break;
    case 'TRADE_CLOSED':
      if (algo.status === 'TRADE_CLOSED') {
        algo.selected = true;
      } else {
        algo.selected = false;
      }
      break;
    case 'READY':
      if (algo.status === 'READY') {
        algo.selected = true;
      } else {
        algo.selected = false;
      }
      break;
    case 'ALL':
      algo.selected = true;
      break;
    case 'NOT_RUNNING':
      if (
        algo.algoStatus &&
        (algo.algoStatus === 'NOT_RUNNING' || algo.algoStatus === 'RED')
      ) {
        algo.selected = true;
      } else {
        algo.selected = false;
      }
      break;
    default:
      algo.selected = false;
  }

  return algo;
};

const selectionSetterByIds = (algo = {}, ids = [], selected = false) => {
  const { _id: algoId = '' } = algo;

  if (!ids || !ids?.length || !ids.includes(algoId)) {
    return algo;
  }

  algo.selected = selected;

  return algo;
};

export const updateBulkSelect = (state, action) => {
  const data = state.data && state.data.data ? state.data.data : [];
  const dataCached =
    state.dataCached && state.dataCached.data ? state.dataCached.data : [];

  if (!data.length) {
    return {
      data: {
        ...state.data,
        data: [],
      },
      dataCached: {
        ...state.dataCached,
        data: [],
      },
    };
  }

  if (!action.data || !action.data.value || !action.data.day) {
    return {
      data: {
        ...state.data,
        data: data,
      },
      dataCached: {
        ...state.dataCached,
        dataCached: data,
      },
    };
  }

  const { dayIndex, found } = findDayIndex(action.data.day, data);

  if (found) {
    data[dayIndex].algos = [
      ...data[dayIndex].algos.map((a) => selectionSetter(a, action.data.value)),
    ];
  }

  // cached
  const { dayIndex2, found2 } = findDayIndex(action.data.day, dataCached);

  if (found2) {
    dataCached[dayIndex2].algos = [
      ...dataCached[dayIndex2].algos.map((a) =>
        selectionSetter(a, action.data.value)
      ),
    ];
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
    dataCached: {
      ...state.dataCached,
      dataCached: data,
    },
  };
};

export const updateRefreshStatusUpdate = (state, action) => {
  const data = state.data && state.data.data ? state.data.data : [];
  const dataCached =
    state.dataCached && state.dataCached.data ? state.dataCached.data : [];
  let updateTime = state.updateTime;
  let isUpdateSkipped = state.isUpdateSkipped;

  if (!data.length) {
    return {
      data: {
        ...state.data,
        data: [],
      },
      dataCached: {
        ...state.dataCached,
        data: [],
      },
      updateTime,
      isUpdateSkipped,
    };
  }

  if (!action.data || !action.data.algo || !action.data.status) {
    return {
      data: {
        ...state.data,
        data: data,
      },
      dataCached: {
        ...state.dataCached,
        data: dataCached,
      },
      updateTime,
      isUpdateSkipped,
    };
  }

  const { algoIndex, dayIndex, found } = findLoactionByAlgoid(
    action.data.algo,
    data
  );

  if (found) {
    if (isStatusUpdated(data[dayIndex].algos[algoIndex], action.data.status)) {
      const now = new Date();
      const diffTime = Math.abs(now - updateTime);

      if (diffTime >= 10000) {
        updateTime = now;
        isUpdateSkipped = false;
      } else {
        isUpdateSkipped = true;
      }

      data[dayIndex].algos[algoIndex].status = action.data.status;
    }
  }

  // cached
  const { algoIndex2, dayIndex2, found2 } = findLoactionByAlgoid(
    action.data.algo,
    dataCached
  );

  if (found2) {
    if (
      isStatusUpdated(
        dataCached[dayIndex2].algos[algoIndex2],
        action.data.status
      )
    ) {
      dataCached[dayIndex2].algos[algoIndex2].status = action.data.status;
    }
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
    dataCached: {
      ...state.dataCached,
      data: dataCached,
    },
    updateTime,
    isUpdateSkipped,
  };
};

export const updateChangeSqOffLoading = (state, action) => {
  const data = state.data && state.data.data ? state.data.data : [];
  const dataCached =
    state.dataCached && state.dataCached.data ? state.dataCached.data : [];

  if (!data.length) {
    return {
      data: {
        ...state.data,
        data: [],
      },
      dataCached: {
        ...state.dataCached,
        data: [],
      },
    };
  }

  if (!action.data || !action.data.id) {
    return {
      data: {
        ...state.data,
        data: data,
      },
      dataCached: {
        ...state.dataCached,
        data: dataCached,
      },
    };
  }

  const { algoIndex, dayIndex, found } = findLoactionByAlgoid(
    action.data.id,
    data
  );

  if (found) {
    data[dayIndex].algos[algoIndex].sqOffLoading = action.data.loading;
  }

  // cached
  const { algoIndex2, dayIndex2, found2 } = findLoactionByAlgoid(
    action.data.id,
    dataCached
  );

  if (found2) {
    dataCached[dayIndex2].algos[algoIndex2].sqOffLoading = action.data.loading;
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
    dataCached: {
      ...state.dataCached,
      data: dataCached,
    },
  };
};

export const updateShiftSelect = (state, action) => {
  const data = state.data && state.data.data ? state.data.data : [];
  const dataCached =
    state.dataCached && state.dataCached.data ? state.dataCached.data : [];

  if (!data.length) {
    return {
      data: {
        ...state.data,
        data: [],
      },
      dataCached: {
        ...state.dataCached,
        data: [],
      },
    };
  }

  if (
    !action.data ||
    !action.data.day ||
    !action.data.ids ||
    !action.data.ids?.length
  ) {
    return {
      data: {
        ...state.data,
        data: data,
      },
      dataCached: {
        ...state.dataCached,
        data: dataCached,
      },
    };
  }

  const { ids, selected } = action.data;

  const { dayIndex, found } = findDayIndex(action.data.day, data);

  if (found) {
    data[dayIndex].algos = [
      ...data[dayIndex].algos.map((algo) =>
        selectionSetterByIds(algo, ids, selected)
      ),
    ];
  }

  // cached
  const { dayIndex2, found2 } = findDayIndex(action.data.day, dataCached);

  if (found2) {
    dataCached[dayIndex2].algos = [
      ...dataCached[dayIndex2].algos.map((algo) =>
        selectionSetterByIds(algo, ids, selected)
      ),
    ];
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
    dataCached: {
      ...state.dataCached,
      data: dataCached,
    },
  };
};

export const updateMultiplierCache = (state, action) => {
  const data = state.data && state.data.data ? state.data.data : [];
  const dataCached =
    state.dataCached && state.dataCached.data ? state.dataCached.data : [];

  if (!data.length) {
    return {
      data: {
        ...state.data,
        data: [],
      },
      dataCached: {
        ...state.dataCached,
        data: [],
      },
    };
  }

  if (!action.data || !action.data.id) {
    return {
      data: {
        ...state.data,
        data: data,
      },
      dataCached: {
        ...state.dataCached,
        data: dataCached,
      },
    };
  }

  const { algoIndex, dayIndex, found } = findLoactionByAlgoid(
    action.data.id,
    data
  );

  if (found) {
    data[dayIndex].algos[algoIndex].multiplierCached = action.data.multiplier;
  }

  // cached
  const { algoIndex2, dayIndex2, found2 } = findLoactionByAlgoid(
    action.data.id,
    dataCached
  );

  if (found2) {
    data[dayIndex2].algos[algoIndex2].multiplierCached = action.data.multiplier;
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
    dataCached: {
      ...state.dataCached,
      data: dataCached,
    },
  };
};

export const updateMultiplierLoading = (state, action) => {
  const data = state.data && state.data.data ? state.data.data : [];
  const dataCached =
    state.dataCached && state.dataCached.data ? state.dataCached.data : [];

  if (!data.length) {
    return {
      data: {
        ...state.data,
        data: [],
      },
      dataCached: {
        ...state.dataCached,
        data: [],
      },
    };
  }

  if (!action.data || !action.data.id) {
    return {
      data: {
        ...state.data,
        data: data,
      },
      dataCached: {
        ...state.dataCached,
        data: dataCached,
      },
    };
  }

  const { algoIndex, dayIndex, found } = findLoactionByAlgoid(
    action.data.id,
    data
  );

  if (found) {
    data[dayIndex].algos[algoIndex].multiplierLoading = action.data.loading;
  }

  // cached
  const { algoIndex2, dayIndex2, found2 } = findLoactionByAlgoid(
    action.data.id,
    dataCached
  );

  if (found2) {
    data[dayIndex2].algos[algoIndex2].multiplierLoading = action.data.loading;
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
    dataCached: {
      ...state.dataCached,
      data: dataCached,
    },
  };
};

export const updateMultiplier = (state, action) => {
  const data = state.data && state.data.data ? state.data.data : [];
  const dataCached =
    state.dataCached && state.dataCached.data ? state.dataCached.data : [];

  if (!data.length) {
    return {
      data: {
        ...state.data,
        data: [],
      },
      dataCached: {
        ...state.dataCached,
        data: [],
      },
    };
  }

  if (!action.data || !action.data.id) {
    return {
      data: {
        ...state.data,
        data: data,
      },
      dataCached: {
        ...state.dataCached,
        data: dataCached,
      },
    };
  }

  const { algoIndex, dayIndex, found } = findLoactionByAlgoid(
    action.data.id,
    data
  );

  if (found) {
    data[dayIndex].algos[algoIndex].multiplier = action.data.multiplier;
  }

  // cached
  const { algoIndex2, dayIndex2, found2 } = findLoactionByAlgoid(
    action.data.id,
    dataCached
  );

  if (found2) {
    dataCached[dayIndex2].algos[algoIndex2].multiplier = action.data.multiplier;
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
    dataCached: {
      ...state.dataCached,
      data: dataCached,
    },
  };
};

export const updateMultiplierReset = (state) => {
  const data = state.data && state.data.data ? state.data.data : [];
  const dataCached =
    state.dataCached && state.dataCached.data ? state.dataCached.data : [];

  if (!data.length) {
    return {
      data: {
        ...state.data,
        data: [],
      },
      dataCached: {
        ...state.dataCached,
        data: [],
      },
    };
  }

  for (let dayIndex = 0; dayIndex < data.length; dayIndex++) {
    const dataDay = data[dayIndex] || {};

    if (dataDay.algos && dataDay.algos.length) {
      for (let algoIndex = 0; algoIndex < dataDay.algos.length; algoIndex++) {
        data[dayIndex].algos[algoIndex].multiplierCached = undefined;
      }
    }
  }

  // cached
  for (let dayIndex = 0; dayIndex < dataCached.length; dayIndex++) {
    const dataDay = dataCached[dayIndex] || {};

    if (dataDay.algos && dataDay.algos.length) {
      for (let algoIndex = 0; algoIndex < dataDay.algos.length; algoIndex++) {
        dataCached[dayIndex].algos[algoIndex].multiplierCached = undefined;
      }
    }
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
    dataCached: {
      ...state.dataCached,
      data: dataCached,
    },
  };
};

export const updateBulkMultiplier = (state, action) => {
  const data = state.data && state.data.data ? state.data.data : [];
  const dataCached =
    state.dataCached && state.dataCached.data ? state.dataCached.data : [];

  if (!data.length) {
    return {
      data: {
        ...state.data,
        data: [],
      },
      dataCached: {
        ...state.dataCached,
        data: [],
      },
    };
  }

  if (!action.data || !action.data.ids || !action.data.ids.length) {
    return {
      data: {
        ...state.data,
        data: data,
      },
      dataCached: {
        ...state.dataCached,
        data: dataCached,
      },
    };
  }

  for (let index = 0; index < action.data.ids.length; index++) {
    const element = action.data.ids[index];

    const { dayIndex, found } = findLoactionByAlgoid(element.id, data);

    if (found) {
      data[dayIndex].algos =
        data[dayIndex].algos.map((a) => {
          if (a._id !== element.id) {
            return a;
          }

          if (element.success && element.success === true) {
            a.multiplier = action.data.value;
          }

          a.selected = false;

          return a;
        }) || [];
    }

    // cached
    const { dayIndex2, found2 } = findLoactionByAlgoid(element.id, dataCached);

    if (found2) {
      dataCached[dayIndex2].algos =
        dataCached[dayIndex2].algos.map((a) => {
          if (a._id !== element.id) {
            return a;
          }

          if (element.success && element.success === true) {
            a.multiplier = action.data.value;
          }

          a.selected = false;

          return a;
        }) || [];
    }
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
    dataCached: {
      ...state.dataCached,
      data: dataCached,
    },
  };
};

export const updateBrokerChange = (state, action) => {
  const data = state.data && state.data.data ? state.data.data : [];
  const dataCached =
    state.dataCached && state.dataCached.data ? state.dataCached.data : [];

  if (!data.length) {
    return {
      data: {
        ...state.data,
        data: [],
      },
      dataCached: {
        ...state.dataCached,
        data: [],
      },
    };
  }

  if (!action.data || !action.data.id) {
    return {
      data: {
        ...state.data,
        data: data,
      },
      dataCached: {
        ...state.dataCached,
        data: dataCached,
      },
    };
  }

  const { algoIndex, dayIndex, found } = findLoactionByAlgoid(
    action.data.id,
    data
  );

  if (found) {
    data[dayIndex].algos[algoIndex].broker = action.data.upadtedData.broker;

    data[dayIndex].algos[algoIndex].brokerClientId =
      action.data.upadtedData.brokerClientId;

    data[dayIndex].algos[algoIndex].brokerDisplayName =
      action.data.upadtedData.brokerDisplayName;
  }

  // cached
  const { algoIndex2, dayIndex2, found2 } = findLoactionByAlgoid(
    action.data.id,
    dataCached
  );

  if (found2) {
    dataCached[dayIndex2].algos[algoIndex2].broker =
      action.data.upadtedData.broker;

    dataCached[dayIndex2].algos[algoIndex2].brokerClientId =
      action.data.upadtedData.brokerClientId;

    dataCached[dayIndex2].algos[algoIndex2].brokerDisplayName =
      action.data.upadtedData.brokerDisplayName;
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
    dataCached: {
      ...state.dataCached,
      data: dataCached,
    },
  };
};
